(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rf-newspetterl-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var KEY_DISMISSED = 'rf-nl-dismissed';
    var KEY_SUBSCRIBED = 'rf-nl-subscribed';

    function store(key, value) {
      try {
        if (value === undefined) return localStorage.getItem(key);
        localStorage.setItem(key, value);
      } catch (e) { return null; }
    }

    function init(el) {
      if (!el || el.dataset.rfInit) return;
      el.dataset.rfInit = '1';

      var inEditor = window.Shopify && Shopify.designMode;
      var box = el.querySelector('.rf-nl__box');
      var lastFocus = null;

      function open() {
        lastFocus = document.activeElement;
        el.hidden = false;
        requestAnimationFrame(function () { el.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        var first = el.querySelector('.rf-nl__input') || el.querySelector('.rf-nl__close');
        if (first) setTimeout(function () { first.focus(); }, 350);
      }

      function close(remember) {
        el.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        setTimeout(function () { el.hidden = true; }, 350);
        if (remember && !inEditor) store(KEY_DISMISSED, String(Date.now()));
        if (lastFocus && lastFocus.focus) lastFocus.focus();
      }

      el.querySelectorAll('[data-rf-nl-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { close(true); });
      });
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close(true);
      });

      el._rfOpen = open;
      el._rfClose = close;

      /* Dopo l'iscrizione: mostra il messaggio di conferma e non riproporre più il popup */
      if (el.querySelector('[data-rf-nl-success]')) {
        store(KEY_SUBSCRIBED, '1');
        open();
        return;
      }

      if (inEditor) return;
      if (el.dataset.enabled !== 'true') return;
      if (store(KEY_SUBSCRIBED)) return;
      if (el.dataset.mobile !== 'true' && window.matchMedia('(max-width: 749px)').matches) return;

      var dismissed = parseInt(store(KEY_DISMISSED) || '0', 10);
      var days = parseInt(el.dataset.days || '14', 10);
      if (dismissed && Date.now() - dismissed < days * 86400000) return;

      setTimeout(open, parseInt(el.dataset.delay || '5', 10) * 1000);
    }

    function initAll() {
      document.querySelectorAll('.rf-nl').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Editor del tema: il popup si apre quando selezioni la sezione */
    document.addEventListener('shopify:section:load', function (e) {
      init(e.target.querySelector('.rf-nl'));
    });
    document.addEventListener('shopify:section:select', function (e) {
      var el = e.target.querySelector('.rf-nl');
      if (el && el._rfOpen) el._rfOpen();
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      var el = e.target.querySelector('.rf-nl');
      if (el && el._rfClose) el._rfClose(false);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
